import { createStore, applyMiddleware, combineReducers } from "redux";
import { createLogger } from "redux-logger";
import thunk from "redux-thunk";
import { dcmPlacements } from "../reducers/dcm/placements";
import { dcmCampaigns } from "../reducers/dcm/campaigns";
import { creatives } from "../reducers/app/creatives";
import { dcmAds } from "../reducers/dcm/ads";
import { dcmAssignedCreatives } from "../reducers/dcm/assignedCreatives";
import { dcmDynamicTargetingKeys } from "../reducers/dcm/dynamicTargetingKeys";
import { globalReducer } from "../reducers/app/global";
import { navigation } from "../reducers/app/navigation";
import { typeGroups } from "../reducers/sql/typeGroups";
import { dcmLandingPages } from "../reducers/dcm/landingPages";
import { placementInfo } from "../reducers/sql/placementInfo";

const rootReducer = combineReducers({
  navigation,
  dcmPlacements,
  dcmCampaigns,
  dcmAds,
  dcmAssignedCreatives,
  dcmLandingPages,
  dcmDynamicTargetingKeys,
  creatives,
  global: globalReducer,
  typeGroups,
  placementInfo
});

const store = createStore(rootReducer, applyMiddleware(thunk, createLogger()));

export default store;
